module.exports = __webpack_public_path__ + "static/sport/bgi-form.dfcbe8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/bgi-form.png
// module id = aFgU
// module chunks = 0